export const CREATE_PRODUCT = 'CREATE_PRODUCT';
export const GET_ALL_PRODUCT = 'GET_ALL_PRODUCT';
export const GET_ID_PRODUCT = 'GET_ID_PRODUCT';
export const SEARCH_PRODUCT = 'SEARCH_PRODUCT';
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';

// Category action types
export const GET_ALL_CATEGORY = 'GET_ALL_CATEGORY';
export const GET_ID_CATEGORY = 'GET_ID_CATEGORY';
export const CREATE_CATEGORY = 'CREATE_CATEGORY';
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY';
export const DELETE_CATEGORY = 'DELETE_CATEGORY';

export const PRODUCT_STATUSES = {
    DRAFT: 'draft',
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    DISCONTINUED: 'discontinued'
};
